import { render, staticRenderFns } from "./mdc-body2.vue?vue&type=template&id=4201fe1c&"
import script from "./mdc-body2.vue?vue&type=script&lang=ts&"
export * from "./mdc-body2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports